import { render, staticRenderFns } from "./Unoapi.vue?vue&type=template&id=4d043cf6&scoped=true"
import script from "./Unoapi.vue?vue&type=script&lang=js"
export * from "./Unoapi.vue?vue&type=script&lang=js"
import style0 from "./Unoapi.vue?vue&type=style&index=0&id=4d043cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d043cf6",
  null
  
)

export default component.exports